var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }
  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }
  return r;
};
import { getType } from "typesafe-actions";
import * as quizAnswer from "./actions";
export var initialState = {
  quizAnswer: {
    languageId: "",
    quizId: "",
    itemAnswers: []
  },
  submitLocked: true,
  itemAnswersReady: {},
  attemptedDisabledSubmit: false,
  noChangesSinceSuccessfulSubmit: false,
  noChangesAfterLoading: true,
  quizDisabled: false,
  pastDeadline: false
};
export var quizAnswerReducer = function quizAnswerReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case getType(quizAnswer.setUnlocked):
      return __assign(__assign({}, state), {
        submitLocked: false
      });
    case getType(quizAnswer.setQuizDisabled):
      return __assign(__assign({}, state), {
        quizDisabled: action.payload
      });
    case getType(quizAnswer.setAnswer):
      var newItemAnswersReady_1 = {};
      var newQuizAnswer = action.payload;
      newQuizAnswer.itemAnswers.forEach(function (ia) {
        newItemAnswersReady_1[ia.quizItemId] = ia.id !== undefined;
      });
      return __assign(__assign({}, state), {
        itemAnswersReady: newItemAnswersReady_1,
        quizAnswer: newQuizAnswer,
        attemptedDisabledSubmit: state.attemptedDisabledSubmit
      });
    case getType(quizAnswer.clear):
      return initialState;
    case getType(quizAnswer.setNoChangesSinceSuccessfulSubmit):
      return __assign(__assign({}, state), {
        noChangesSinceSuccessfulSubmit: true
      });
    case getType(quizAnswer.setLocked):
      return __assign(__assign({}, state), {
        submitLocked: true
      });
    case getType(quizAnswer.pastDeadline):
      return __assign(__assign({}, state), {
        pastDeadline: true
      });
    case getType(quizAnswer.setAttemptedSubmit):
      return __assign(__assign({}, state), {
        attemptedDisabledSubmit: true
      });
    case getType(quizAnswer.clearAttemptedSubmit):
      return __assign(__assign({}, state), {
        attemptedDisabledSubmit: false
      });
    case getType(quizAnswer.changeIntDataAction):
      newItemAnswersReady_1 = __assign({}, state.itemAnswersReady);
      newItemAnswersReady_1["" + action.payload.itemId] = true;
      return __assign(__assign({}, state), {
        submitLocked: !readyToSubmit(newItemAnswersReady_1),
        itemAnswersReady: newItemAnswersReady_1,
        quizAnswer: __assign(__assign({}, state.quizAnswer), {
          itemAnswers: state.quizAnswer.itemAnswers.map(function (ia) {
            return ia.quizItemId === action.payload.itemId ? __assign(__assign({}, ia), {
              intData: action.payload.newValue
            }) : ia;
          })
        }),
        noChangesSinceSuccessfulSubmit: false,
        noChangesAfterLoading: false
      });
    case getType(quizAnswer.changeTextDataAction):
      newItemAnswersReady_1 = __assign({}, state.itemAnswersReady);
      newItemAnswersReady_1["" + action.payload.itemId] = action.payload.readyToSubmit;
      return __assign(__assign({}, state), {
        submitLocked: !readyToSubmit(newItemAnswersReady_1),
        itemAnswersReady: newItemAnswersReady_1,
        quizAnswer: __assign(__assign({}, state.quizAnswer), {
          itemAnswers: state.quizAnswer.itemAnswers.map(function (ia) {
            return ia.quizItemId === action.payload.itemId ? __assign(__assign({}, ia), {
              textData: action.payload.newValue
            }) : ia;
          })
        }),
        noChangesSinceSuccessfulSubmit: false,
        noChangesAfterLoading: false
      });
    case getType(quizAnswer.changeCheckboxDataAction):
      newItemAnswersReady_1 = __assign({}, state.itemAnswersReady);
      newItemAnswersReady_1["" + action.payload.itemId] = true;
      return __assign(__assign({}, state), {
        submitLocked: !readyToSubmit(newItemAnswersReady_1),
        itemAnswersReady: newItemAnswersReady_1,
        quizAnswer: __assign(__assign({}, state.quizAnswer), {
          itemAnswers: state.quizAnswer.itemAnswers.map(function (ia) {
            return ia.quizItemId === action.payload.itemId ? __assign(__assign({}, ia), {
              intData: ia.intData === 1 ? 0 : 1
            }) : ia;
          })
        }),
        noChangesSinceSuccessfulSubmit: false,
        noChangesAfterLoading: false
      });
    case getType(quizAnswer.chooseOptionAction):
      newItemAnswersReady_1 = __assign({}, state.itemAnswersReady);
      newItemAnswersReady_1["" + action.payload.itemId] = true;
      var _a = action.payload,
        itemId_1 = _a.itemId,
        optionId_1 = _a.optionId,
        multi = _a.multi;
      var current = state.quizAnswer.itemAnswers.find(function (ia) {
        return ia.quizItemId === itemId_1;
      });
      if (current === undefined) {
        return state;
      }
      var newItemAnswer = __assign({}, current);
      var previouslyChosen = newItemAnswer.optionAnswers.some(function (oa) {
        return oa.quizOptionId === optionId_1;
      });
      if (previouslyChosen) {
        var remainingChosenOptions = current.optionAnswers.filter(function (oa) {
          return oa.quizOptionId !== optionId_1;
        }).length;
        if (remainingChosenOptions <= 0) {
          newItemAnswersReady_1["" + action.payload.itemId] = false;
        }
        return __assign(__assign({}, state), {
          submitLocked: !readyToSubmit(newItemAnswersReady_1),
          itemAnswersReady: newItemAnswersReady_1,
          quizAnswer: __assign(__assign({}, state.quizAnswer), {
            itemAnswers: state.quizAnswer.itemAnswers.map(function (ia) {
              return ia.quizItemId !== itemId_1 ? ia : __assign(__assign({}, ia), {
                optionAnswers: ia.optionAnswers.filter(function (oa) {
                  return oa.quizOptionId !== optionId_1;
                })
              });
            })
          }),
          noChangesSinceSuccessfulSubmit: false,
          noChangesAfterLoading: false
        });
      }
      var newOptionAnswers_1 = multi ? __spreadArrays(newItemAnswer.optionAnswers).concat({
        quizOptionId: optionId_1
      }) : [{
        quizOptionId: optionId_1
      }];
      return __assign(__assign({}, state), {
        submitLocked: !readyToSubmit(newItemAnswersReady_1),
        itemAnswersReady: newItemAnswersReady_1,
        quizAnswer: __assign(__assign({}, state.quizAnswer), {
          itemAnswers: state.quizAnswer.itemAnswers.map(function (ia) {
            return ia.quizItemId !== itemId_1 ? ia : __assign(__assign({}, ia), {
              optionAnswers: newOptionAnswers_1
            });
          })
        }),
        noChangesSinceSuccessfulSubmit: false,
        noChangesAfterLoading: false
      });
    default:
      return state;
  }
};
var readyToSubmit = function readyToSubmit(answerStatuses) {
  for (var itemId in answerStatuses) {
    if (!answerStatuses[itemId]) {
      return false;
    }
  }
  return true;
};